import React from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { ArrowLeft, Calendar, Tag } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { news } from '../mock';

const NewsDetailPage = () => {
  const { slug } = useParams();
  const article = news.find((n) => n.slug === slug);
  if (!article) return <Navigate to="/news" replace />;
  const others = news.filter((n) => n.slug !== slug);

  return (
    <div className="App bg-white">
      <Header />

      <section className="max-w-[880px] mx-auto px-6 pt-14">
        <Link to="/news" className="inline-flex items-center gap-1 text-[13px] text-neutral-500 hover:text-neutral-900 transition-colors">
          <ArrowLeft size={14} /> Back to News
        </Link>
        <div className="mt-6 flex items-center gap-4 text-[13px] text-neutral-500">
          <span className="inline-flex items-center gap-1"><Tag size={13} /> {article.tag}</span>
          <span className="inline-flex items-center gap-1"><Calendar size={13} /> {article.date}</span>
        </div>
        <h1 className="mt-4 text-[38px] lg:text-[52px] leading-[1.02] font-bold tracking-[-0.03em] text-neutral-900">
          {article.title}
        </h1>
      </section>

      <section className="max-w-[880px] mx-auto px-6 mt-10">
        <div className="rounded-[24px] overflow-hidden aspect-[16/9] bg-neutral-100">
          <img src={article.image} alt={article.title} className="w-full h-full object-cover" />
        </div>

        <article className="mt-10 space-y-5 text-[17px] leading-[1.7] text-neutral-800">
          {article.body.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </article>
      </section>

      <section className="max-w-[1240px] mx-auto px-6 py-20">
        <h2 className="text-[26px] lg:text-[32px] font-bold tracking-tight text-neutral-900">Continue reading</h2>
        <div className="mt-8 grid md:grid-cols-2 gap-6">
          {others.map((n) => (
            <Link key={n.id} to={`/news/${n.slug}`} className="group rounded-[20px] border border-neutral-200 overflow-hidden hover:border-[#CA0028] transition-colors">
              <div className="aspect-[16/9] overflow-hidden bg-neutral-100">
                <img src={n.image} alt={n.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-5">
                <div className="text-[12px] text-neutral-500">{n.tag} · {n.date}</div>
                <h3 className="mt-2 text-[17px] font-semibold text-neutral-900 group-hover:text-[#CA0028] transition-colors">{n.title}</h3>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default NewsDetailPage;
